import { Filter, Visualization } from '../../../core/models';
import { share } from 'rxjs/operators';
import { StoreLite } from '@mailok/store-lite';
import { cssNormal } from '../../utils';

export const titleWindow = 'Gestionar Filtros';
export const titleErrorWindow = 'Error';
export const titleConfirmationWindow = 'Confirmación';

export interface FilterDialogState {
    title: string;
    headClass: string;
    loading: boolean;
    selected: Filter[];
    visualizationSelected: Visualization | null;
}

export class FilterDialogStore extends StoreLite<FilterDialogState> {
    title$ = this.select<string>(store => store.title);
    headClass$ = this.select<string>(store => store.headClass).pipe(share());
    selected$ = this.select<Filter[]>(store => store.selected).pipe(share());
    visualizationSelected$ = this.select<Visualization | null>(store => store.visualizationSelected).pipe(share());
    constructor() {
        super({
            title: titleWindow,
            headClass: cssNormal,
            loading: false,
            selected: [],
            visualizationSelected: null
        });
    }

    updateTile(title: string): void {
        this.update({ title });
    }

    updateHeadClass(headClass: string): void {
        this.update({ headClass });
    }

    updateSelected(selected: Filter[]): void {
        this.update({ selected });
    }

    updateVisualizationSelected(visualizationSelected: Visualization | null): void {
        this.update({ visualizationSelected });
    }

    getSelected(): Filter[] {
        return this.selectSnapshot(store => store.selected);
    }

    getVisualizationSelected(): Visualization | null {
        return this.selectSnapshot(store => store.visualizationSelected);
    }
}
